export default {
  props: ['activeItem'],
  computed: {
    pages() {
      return [
        {
          path: this.i18nLink('account/profile'),
          name: this.$t('account.profile'),
          isActive: this.activeItem === 'profile',
          num: 0,
        },
        {
          path: this.i18nLink('account/invoices'),
          name: this.$t('account.invoices'),
          isActive: this.activeItem === 'invoices',
          num: 0,
        },
        {
          path: this.i18nLink('account/personal_albums'),
          name: this.$t('account.personal_albums'),
          isActive: this.activeItem === 'personal_albums',
          num: 0,
        },
        {
          path: this.i18nLink('account/downloads'),
          name: this.$t('account.downloads'),
          isActive: this.activeItem === 'downloads',
          num: this.downloads.length,
        },
      ];
    },
  },
  async created() {
    if (!this.downloads && this.$router.currentRoute.path !==
        `/${this.$i18n.locale}/account/downloads`) {
      try {
        const downloads = await this.axios.get('orders/get_order_downloads');

        if (downloads) {
          this.$store.commit('SET_DOWNLOADS', downloads.data.data);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }
  },
};
